import React from "react";

type LoadingSkeletonProps = {
  rows: number;
  primaryClass?: string;
  secondryClass?: string;
};

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({
  rows,
  primaryClass,
  secondryClass,
}) => (
  <div className={primaryClass}>
    {Array.from({ length: rows }).map((_, index) => (
      <div key={index} className={`animate-pulse ${secondryClass}`}></div>
    ))}
  </div>
);

export default LoadingSkeleton;
